"use client"

import {
    SidebarMenu as ShadcnSidebarMenu,
    SidebarMenuItem,
    SidebarMenuButton,
} from "@workspace/ui/components/shadcn/sidebar"

export function SidebarMenu({
    items,
    pathname,
    LinkComponent,
}: {
    items: { label: string; href: string; icon?: any }[]
    pathname: string
    LinkComponent: any
}) {
    return (
        <ShadcnSidebarMenu>
            {items.map((item) => {
                const Icon = item.icon
                const active = pathname === item.href

                return (
                    <SidebarMenuItem key={item.href}>
                        <SidebarMenuButton
                            asChild
                            className={active ? "bg-accent text-accent-foreground" : ""}
                        >
                            <LinkComponent href={item.href} className="flex items-center gap-3">
                                {Icon && <Icon size={18} />}
                                {item.label}
                            </LinkComponent>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                )
            })}
        </ShadcnSidebarMenu>
    )
}
